import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { Snapshot } from '@/components/marangatu-snapshot-view';

export interface RequiredDeclaration {
  codigo: number;
  nombre: string;
  formCode: string | null;
  kind: string | null;
  cadencia: string | null;
}

export interface SetSnapshotResponse {
  snapshot: Snapshot | null;
  requiredDeclarations: RequiredDeclaration[];
  /** Impuesto a la renta derivado de las obligaciones de SET. null si no hay. */
  rentaImpuesto: 'IRP' | 'IRE' | null;
}

/**
 * Snapshot oficial de SET del tenant (read-only). Una sola query compartida por
 * `/api/app/set-access/snapshot` — React Query la dedupe entre el perfil, IVA y
 * Renta (mismo queryKey).
 */
export function useSetSnapshot() {
  return useQuery({
    queryKey: ['app-mar-snapshot'],
    queryFn: () => api<SetSnapshotResponse>('/api/app/set-access/snapshot'),
  });
}
